function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.3 18.7h16.4V2.3H2.3zM19.9 0A1.1 1.1 0 0121 1.1v18.8a1.1 1.1 0 01-1.1 1.1H1.1A1.1 1.1 0 010 19.9V1.1A1.1 1.1 0 011.1 0zm-5.5 6.7H4.7a.6.6 0 01-.6-.5V5.1a.6.6 0 01.6-.6h9.7a.6.6 0 01.6.6v1.1a.6.6 0 01-.6.5zm0 9.8H4.7a.6.6 0 01-.6-.6v-1.1a.6.6 0 01.6-.5h9.7a.6.6 0 01.6.5v1.1a.6.6 0 01-.6.6zm-9.7-4.9a.6.6 0 01-.6-.5V9.9a.6.6 0 01.6-.5h5.6a.6.6 0 01.6.5v1.2a.6.6 0 01-.6.5z",
  fillRule: "evenodd"
});

var SvgDetails = function SvgDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    id: "ic-details",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/details.0c568947.svg";
export { ForwardRef as ReactComponent };